import { Checkbox } from '~/components/Form';

import type { InputFieldCheckboxProps as Props } from './types';

export const InputFieldCheckbox = ({ checked, children, onCheckedChange, step }: Props) => {
  return (
    <Checkbox.Root checked={checked} name={step} onCheckedChange={onCheckedChange}>
      <Checkbox.Label>{children}</Checkbox.Label>
    </Checkbox.Root>
  );
};
